import './order-details.scss';
import Component from '../../components/component/component';

export default class OrderDetails extends Component {
    static initSelector: string = '.order-details';

    public viewToggle: HTMLElement;

    constructor(element: HTMLElement) {
        super(element);

        this.viewToggle = this.element.querySelector('.order-details__view-toggle');

        this.init();
    }

    init(): void {
        this.viewToggle.addEventListener('click', this.viewToggleHandler.bind(this));
    }

    viewToggleHandler(): void {
        this.element.querySelector('.order-details__content').classList.toggle('is-visible');
        this.viewToggle.classList.toggle('is-open');
    }
}
